<template>
  <div>
    <ion-list-header>
      <ion-label>{{ $t("bookings.driverDocs") }}</ion-label>
    </ion-list-header>
    <p class="multiple">{{ $t("bookings.documentsDrivers") }}</p>
    <ion-list v-model="valid">
      <file-uploader-component
        :title="$t('bookings.idDocFront')"
        :multiple="true"
        v-model="form.id_front"
      ></file-uploader-component>
      <file-uploader-component
        :title="$t('bookings.idDocBack')"
        :multiple="true"
        v-model="form.id_back"
      ></file-uploader-component>
      <file-uploader-component
        :title="$t('bookings.driverLicenseFront')"
        :multiple="true"
        v-model="form.driver_license_front"
      ></file-uploader-component>
      <file-uploader-component
        :title="$t('bookings.driverLicenseBack')"
        :multiple="true"
        v-model="form.driver_license_back"
      ></file-uploader-component>
    </ion-list>
  </div>
</template>

<script>
import axios from "axios";
import FileUploaderComponent from "../FileUploaderComponent";
import CountrySelect from "../CountrySelect";
import { defineComponent } from "vue";
import { IonList, IonItem, IonLabel, IonInput } from "@ionic/vue";
import useVuelidate from "@vuelidate/core";
import { required, email } from "@vuelidate/validators";

export default defineComponent({
  setup() {
    return {
      v$: useVuelidate(),
    };
  },
  props: {
    modelValue: {
      required: false,
      type: Array,
    },
  },
  components: {
    FileUploaderComponent,
    IonList,
  },
  data: () => ({
    valid: false,
    form: {
      id_front: null,
      id_back: null,
      driver_license_front: null,
      driver_license_back: null,
    },
  }),
  validations() {
    return {
      form: {
        id_front: { required },
        id_back: { required },
        driver_license_front: { required },
        driver_license_back: { required },
      },
    };
  },
  watch: {
    form: {
      deep: true,
      handler(newVal) {
        this.$emit("update:modelValue", newVal);
        this.$emit("valid", 8, !this.v$.$invalid);
      },
    },
  },
  methods: {
    
  },
});
</script>

<style lang="scss">
.v-text-field__details {
  display: none;
}
.error--text .v-text-field__details {
  display: inline;
}
.filepond--wrapper {
  margin: 10px;
}
.multiple {
  font-size: 16px;
  color: gray;
  padding: 0 16px;
  margin: 6px 0;
}
</style>
